import { IAddress } from 'types/Address.types';
import { ICompanySettings } from 'types/Company.types';

export enum EditCompanyDataTab {
  DETAILS = 'Details',
  ADDRESS = 'Address',
}

export interface IEditCompanyDataDTO {
  name: string;
  vat_number: string;
  coc_number: string;
  website: string | null;
  email: string;
  phone_number: string | null;
  address?: IAddress;
  company_settings?: ICompanySettings;
}

export interface ICompanyDetails {
  name: string;
  vat_number: string;
  coc_number: string;
  phone_number: string;
  website: string;
  email: string;
}
